var SearchMixin = {
    binarySearch: function (search, where) {
        let index = -1;
        let i = 0;
        let f = false;

        let searchTerms = [];
        let whereTerms  = [];
        let startIndex  = 0;
        let stopIndex   = 0;
        let middle      = 0;

        if (Array.isArray(search) === false) {
            search = [search];
        }

        if (where.length < search.length) {
            searchTerms = where;
            whereTerms  = search;
        }
        else {
            searchTerms = search;
            whereTerms  = where;
        }

        whereTerms.sort();
        searchTerms.sort();

        startIndex  = 0;
        stopIndex   = whereTerms.length - 1;
        middle      = Math.floor((stopIndex + startIndex)/2);

        // No real binaray search required
        if (searchTerms.length === 1 && whereTerms.length === 1 && searchTerms[0] === whereTerms[0]) {
            return 0;
        }

        for (i = 0; i < searchTerms.length; i++){
 
            while(whereTerms[middle] != searchTerms[i] && startIndex < stopIndex){
        
                //adjust search area
                if (searchTerms[i] < whereTerms[middle]){
                    stopIndex = middle - 1;
                    if (stopIndex < 0) {
                        stopIndex = 0;
                    }
                } else if (searchTerms[i] > whereTerms[middle]){
                    startIndex = middle + 1;
                    if (startIndex > whereTerms.length - 1) {
                        stopIndex = whereTerms.length - 1;
                    }
                }
        
                //recalculate middle
                middle = Math.floor((stopIndex + startIndex)/2);
                if (middle < 0) {
                    middle = 0;
                }
            }

            index = (whereTerms[middle] != searchTerms[i]) ? -1 : middle;

            if (index > -1) {
                f = true;
                break;
            }
        }

        if (f === true) {
            return index;
        }

        return -1;

    }
}; 

export default SearchMixin;